export default __webpack_public_path__ + "static/media/keyvisual-jena.e8278512.jpg";